import UpsellImage from '../assets/images/upsell_memory_recall.png';

export const SHOP_UPSELLS = {
  'upsell-memory-recall': {
    titleKey: 'shopScreen.memorySparkGuide',
    image: UpsellImage,
  },
  'product-digital-book-credits-v1-1x': {
    titleKey: 'shopScreen.additionalBooks',
    quantity: 1,
    image:
      'https://cdn.shopify.com/s/files/1/0562/9611/2222/files/additional_books_1.png?v=1729696249',
  },
  'product-digital-book-credits-v1-2x': {
    titleKey: 'shopScreen.additionalBooks',
    quantity: 2,
    image:
      'https://cdn.shopify.com/s/files/1/0562/9611/2222/files/additional_books_2.png?v=1729696249',
  },
  'product-digital-book-credits-v1-4x': {
    titleKey: 'shopScreen.additionalBooks',
    quantity: 4,
    image:
      'https://cdn.shopify.com/s/files/1/0562/9611/2222/files/additional_books_4.png?v=1729696249',
  },
  'product-digital-book-credits-v1-6x': {
    titleKey: 'shopScreen.additionalBooks',
    quantity: 6,
    image:
      'https://cdn.shopify.com/s/files/1/0688/8220/2864/files/additional_books_6.png?v=1736262648',
  },
  'product-digital-book-credits-v1-8x': {
    titleKey: 'shopScreen.additionalBooks',
    quantity: 8,
    image:
      'https://cdn.shopify.com/s/files/1/0688/8220/2864/files/additional_books_8.png?v=1736262647',
  },
  'product-digital-book-credits-v1-10x': {
    titleKey: 'shopScreen.additionalBooks',
    quantity: 10,
    image:
      'https://cdn.shopify.com/s/files/1/0688/8220/2864/files/additional_books_10.png?v=1736262648',
  },
};
